import React from "react";
import { ICoverOptionsSectionProps } from "./CoverOptionsSection.types";
import "./CoverOptionsSection.scss";
import PricingCards from "../PricingCards";

export default function CoverOptionsSection(props: ICoverOptionsSectionProps) {
  return (
    <div className="CoverOptionsSection">
      <div className="cover-options-header">
        <h2 className="cover-options-header-title">Different ways to customise your cover</h2>
        <p className="cover-options-header-description">
          Unlike many other pet insurance products, regardless of the annual limit you choose, you'll be covered for the same  list of injuries, illnesses and conditions with Petsy. And, you can customise your coverage. 
           <div style={{ marginTop: '12px' }} />
           Here are three "pre-selected options" that you can choose, or you can customise it yourself.
        </p>
      </div>
      <PricingCards 
        className="PricingCards"
        stepSlug={props.stepSlug}
      />
    </div>
  );
}
